import moment from "moment";

export const formatDate = date => {
    const formatedStr = date ? `${moment(date).format("ddd, MMM D, YY")}` : "";
    return formatedStr;
}

export const formatDateTime = date => {
    const formatedStr = date ? `${moment(date).format("ddd, MMM D, YY HH:mm A")}` : "";
    return formatedStr;
}

export const formatSurveyDate = (date, defaultStr = "") => {
    if (date) {
        if ((new Date()).getFullYear() === (new Date(date)).getFullYear())
            return `${moment(date).format("ddd, MMM D")}`;
        else
            return `${moment(date).format("ddd, MMM D, YY")}`;
    }
    return defaultStr;
}

export const formatTime = date => {
    return date ? `${moment(date).format("HH:mm")}` : date;
}

export const buildTime = (timeStr) => {
    if (timeStr) {
        const hourParts = timeStr.split(':');
        if (hourParts.length === 2) {
            return moment()
                .set('hour', hourParts[0])
                .set('minute', hourParts[1])
                .toISOString()
        } else {
            return null;
        }
    }
    return timeStr;
}

